<template>
  <converter
    conversionType="WMS"
    title="WMS URL Conversion"
    prependIcon="http"
    iconClass="teal white--text"
    :urlInput="true"
  ></converter>
</template>
<script>
  import Converter from '@/components/GeoConverter';

  export default {
    name: 'wms-converter',
    components: {
      converter: Converter,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/converter/WMSConverter.vue